const sizes = {
   // Layout
   siteHeaderHeight: '80px',
   siteFooterHeight: '110px',
   contentWidth: '1200px',
   contentSidePadding: '1.5rem',
};

export { sizes };
